import React from 'react';
import './feature.css';

// Feature component accepts title and text and props.
// If we don't pass title/text in as props, {title} and/or {text} would be "undefined"
const Feature = ({ title, text }) => (
  <div className="gpt3__features-container__feature">
    <div className="gpt3__features-container__feature-title">
      {/* Next div is our little line bar above the title */}
      <div />
      <h1>{title}</h1>
    </div>
    <div className="gpt3__features-container_feature-text">
      <p>{text}</p>
    </div>
  </div>
);

export default Feature;